import { Component, Prop, Vue } from "vue-property-decorator";
import { InputChipData } from "./models/InputChipData";

@Component({
  name: "InputChipString"
})
export default class InputChipString extends Vue {
  @Prop() label!: string;
  @Prop() value!: InputChipData[];
  @Prop({ default: () => true }) edit!: boolean;
  @Prop({ default: () => true }) isCollapse!: boolean;
  @Prop({ default: () => false }) required!: boolean;

  inInput = false;
  refresh = 0;

  selectInput() {
    this.inInput = true;
    this.$emit("click");
  }

  get canInputActive() {
    return this.inInput || this.value.length >= 1;
  }

  enableFormInput() {
    this.inInput = true;
    this.$emit("openInputs", !this.isCollapse);
  }

  get inputLocal(): InputChipData[] {
    this.refresh = 1 - this.refresh;
    return this.value;
  }

  set inputLocal(newInput: InputChipData[]) {
    this.$emit("input", newInput);
  }

  getText(dato: InputChipData) {
    return `${dato.name}~${dato.field?.title}`;
  }
  deleteElement(index: number) {
    this.inputLocal.splice(index, 1);
  }

  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  changeString(evt: any) {
    const tempNewValues: InputChipData[] = [];
    const newValues: InputChipData[] = [];
    /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
    evt.target.childNodes.forEach((child: any) => {
      const otherValue: InputChipData = { type: "", name: "" };

      if (
        child.nodeName == "#text" ||
        !(child.textContent as string).includes("~")
      ) {
        otherValue.type = "string";
        otherValue.name = child.textContent;
      } else {
        const newValue: InputChipData = { type: "", name: "" };
        const childOfChild = child.childNodes;
        if (childOfChild.length == 3 && childOfChild[2].nodeName == "#text") {
          otherValue.type = "string";
          otherValue.name = childOfChild[2].textContent;
        }

        const dato = (child.textContent as string).split("~");
        if (dato.length == 2) {
          newValue.name = dato[0];
          newValue.field = {
            key: "",
            title: dato[1].replace(otherValue.name, ""),
            type: ""
          };
        }

        if (newValue.name == "") {
          return;
        }
        tempNewValues.push(newValue);
        if (otherValue.type == "") {
          return;
        }
      }
      if (
        tempNewValues.length >= 1 &&
        tempNewValues[tempNewValues.length - 1].type == "string"
      ) {
        tempNewValues[tempNewValues.length - 1].name += otherValue.name;
        return;
      }
      if (otherValue.name == "") {
        return;
      }

      tempNewValues.push(otherValue);
    });

    let indexInputLocal = 0;
    tempNewValues.forEach(value => {
      if (value.type == "string") {
        newValues.push(value);
        return;
      }

      for (let i = indexInputLocal; i < this.inputLocal.length; i++) {
        const inputLocalSelect = this.inputLocal[i];

        if (
          inputLocalSelect.name.trim() == value.name.trim() &&
          inputLocalSelect.field?.title.trim() == value.field?.title.trim()
        ) {
          indexInputLocal = i;

          newValues.push(inputLocalSelect);
          break;
        }
      }
    });

    this.inputLocal = [...newValues];
  }
}
